import React from 'react';
import { Box } from 'rebass';
import { UtilityIconButton } from '../Button/UtilityIconButton';

export interface ThirdPanePaginationProps {
  onPrev?: () => void;
  onNext?: () => void;
  prevEnabled?: boolean;
  nextEnabled?: boolean;
}

const ThirdPanePagination = (props: ThirdPanePaginationProps): JSX.Element => {
  return (
    <Box py={1} pl={2} sx={{ flexShrink: 0 }}>
      {props.onPrev && (
        <UtilityIconButton
          disabled={props.prevEnabled === false}
          mr="2"
          onClick={props.onPrev}
          icon="chevron-left"
          dark
        />
      )}
      {props.onNext && (
        <UtilityIconButton
          disabled={props.nextEnabled === false}
          onClick={props.onNext}
          icon="chevron-right"
          dark
        />
      )}
    </Box>
  );
};

export default ThirdPanePagination;
